import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMaximizeIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 15 15",
	style: { enableBackground: "new 0 0 15 15" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	    .maximize-icon-st0{fill:currentColor;}\n    "
	}), /* @__PURE__ */ _jsx("path", {
		className: "maximize-icon-st0",
		d: "m 5.1780862,1.4277034 c -0.6874993,0 -1.2503827,0.5628834 -1.2503827,1.2503827 V 4.1654794 H 5.1780862 V 2.6780861 h 1.485874 V 1.4277034 Z m 6.0088258,0 v 1.2503827 h 1.490432 v 1.4873933 h 1.250383 V 2.6780861 c 0,-0.6874993 -0.562884,-1.2503827 -1.250383,-1.2503827 z M 3.9277035,8.6899506 v 1.4873934 c 0,0.687499 0.5628834,1.250383 1.2503827,1.250383 H 6.6654795 V 10.177344 H 5.1780862 V 8.6899506 Z m 8.7496405,0 v 1.4873934 h -1.487393 v 1.250383 h 1.487393 c 0.687499,0 1.250383,-0.562884 1.250383,-1.250383 V 8.6899506 Z",
		transform: "matrix(1.2855439,0,0,1.2855439,-3.9769696,-0.76310981)"
	})]
});
export default SvgMaximizeIcon;
